import { urlize } from '@common/helpers/url';
import { RESOURCE_CENTER_PATH } from '@sly/core/constants/dashboardAppPaths';
import cx from 'classnames';
import { array, node, object } from 'prop-types';
import React, { useCallback } from 'react';
import { useHistory } from 'sly/lib/react-router';
import Link from 'sly/system/Link';

const Tag = ({ children, className, ...rest }) => (
  <Link
    className={cx(
      'font-l-m inline-block max-w-max',
      'cursor-pointer text-ellipsis whitespace-nowrap',
      'rounded bg-viridian-base py-xxs px-xs uppercase',
      '!text-white hover:bg-viridian-darker-20',
      'active:bg-viridian-darker-40',
      className
    )}
    {...rest}
    data-tp-id='gen-div-953ff737-1007-48af-a9fd-827bed32ba44'
  >
    {children}
  </Link>
);

Tag.propTypes = {
  children: node,
};

const ArticleTags = ({ topic, tagsList }) => {
  const { push } = useHistory();
  const onClick = useCallback(
    (tag) => (evt) => {
      evt.stopPropagation();
      evt.preventDefault();
      push(`${RESOURCE_CENTER_PATH}/tag/${tag}`);
      window.scrollTo(0, 0);
    },
    [topic]
  );

  return (
    <>
      {!!tagsList?.filter(({ value }) => value).length && (
        <div
          className='z-[1] flex flex-grow flex-nowrap content-end items-end'
          data-tp-id='gen-div-8915680e-a17d-4391-a8e8-66ed09081b32'
        >
          {tagsList
            .sort(
              ({ value: firstValue }, { value: secondValue }) =>
                firstValue.length - secondValue.length
            )
            .map(({ value, id }, idx) => (
              <Tag
                key={id || value}
                to={`${RESOURCE_CENTER_PATH}/tag/${urlize(value)}`}
                className={cx(
                  'mr-xxs mt-xxxs h-max w-full',
                  idx !== 0 && 'overflow-hidden'
                )}
              >
                {value.replace(/_/g, ' ')}
              </Tag>
            ))}
        </div>
      )}
      {!tagsList?.length && topic && (
        <Tag
          className='mt-auto w-max'
          to={`${RESOURCE_CENTER_PATH}/${topic.slug}`}
        >
          {topic.name}
        </Tag>
      )}
    </>
  );
};

ArticleTags.propTypes = {
  topic: object,
  tagsList: array,
};

export default ArticleTags;
